import Vue from 'vue'
import HMButton from './baseComponents/hm-button'
import HMSelect from './baseComponents/hm-select'

const components = [HMButton, HMSelect]

components.forEach(component => {
    Vue.component(component.name, component)
})

export default {
    HMButton,
    HMSelect
}


// WEBPACK FOOTER //
// ./src/components/index.js